import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button, Modal, Section } from '@weezevent/nacre';

import ConditionDetails from './details';

const ConditionModal = ({ organization, flowId, state, onClose, sync }) => {
    const { t } = useTranslation();

    const [datas, setDatas] = React.useState({
        errors: false,
        onSave: () => {}
    });

    const handleSave = React.useCallback(() => {
        datas.onSave().then(() => {
            onClose();
            sync();
        });
    }, [datas.onSave, onClose, sync]);

    return (
        <Modal
            onClose={onClose}
            size="extralarge"
            open={Boolean(state.open)}
            allowExternalClosing={false}
            title={t('ticket.moderation.statusesTransitions.conditions.detail.titleAdd')}
            subtitle={t('ticket.moderation.statusesTransitions.conditions.detail.subtitleAdd')}
            submitButton={<Button primary onClick={handleSave} label={t('ticket.common.cta.save')} disabled={datas.errors} />}
            cancelButton={onClose && <Button onClick={onClose} label={t('ticket.common.cta.cancel')} />}
        >
            <Section>
                <ConditionDetails modal organization={organization} flowId={flowId} conditionId={state.id} setExternalDatas={setDatas} />
            </Section>
        </Modal>
    );
};

export default ConditionModal;
